import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const EditSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default EditSVG;
